import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1d8b5a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-index" }
const _hoisted_2 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal fd-index-carousel"
}
const _hoisted_3 = { class: "el-carousel__container" }
const _hoisted_4 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_5 = { class: "fd-center fd-index-ct" }
const _hoisted_6 = { class: "fd-index-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-name" }, "楼盘招商"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-sub" }, "拎包招商项目一手掌握")
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("最新上线项目 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("招商项目查询")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全国招商项目统计")
const _hoisted_11 = { class: "fd-index-box-tabs" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "fd-index-box-item-img" }
const _hoisted_14 = { class: "fd-index-box-item-info" }
const _hoisted_15 = { class: "fd-index-box-item-info-tp-lt" }
const _hoisted_16 = { class: "fd-index-box-item-info-tp-lt-name" }
const _hoisted_17 = { class: "fd-index-box-item-info-tp-label" }
const _hoisted_18 = { class: "fd-invest-box-item-info-bt-name" }
const _hoisted_19 = { style: {"position":"relative","top":"-8px"} }
const _hoisted_20 = { class: "fd-index-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-name" }, "社区营销"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-sub" }, "拎包营销活动全景赏析")
], -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("业主见面会")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("拎包样板间")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("商家营销活动 ")
const _hoisted_25 = { class: "fd-index-box-tabs" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "fd-index-box-item-img" }
const _hoisted_28 = { class: "fd-index-box-item-info" }
const _hoisted_29 = { class: "fd-index-box-item-info-tp-lt" }
const _hoisted_30 = { class: "fd-index-box-item-info-tp-lt-name" }
const _hoisted_31 = { class: "fd-index-box-item-info-ct" }
const _hoisted_32 = { class: "fd-index-box-item-info-bt-name" }
const _hoisted_33 = { class: "fd-index-box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-name" }, "拎包培训"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-sub" }, "拎包训练营一站参与")
], -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("全国巡回培训 ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("学员招募")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("培训剪影")
const _hoisted_38 = { class: "fd-index-box-tabs" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "fd-index-box-item-img" }
const _hoisted_41 = {
  key: 0,
  class: "fd-index-box-item-img-status status3"
}
const _hoisted_42 = { class: "fd-index-box-item-img-label" }
const _hoisted_43 = {
  key: 1,
  class: "fd-index-box-item-img-status status4"
}
const _hoisted_44 = { class: "fd-index-box-item-img-label" }
const _hoisted_45 = {
  key: 2,
  class: "fd-index-box-item-img-status status5"
}
const _hoisted_46 = { class: "fd-index-box-item-img-label" }
const _hoisted_47 = {
  key: 3,
  class: "fd-index-box-item-img-status status6"
}
const _hoisted_48 = { class: "fd-index-box-item-img-label" }
const _hoisted_49 = { class: "fd-index-box-item-info" }
const _hoisted_50 = { class: "fd-index-box" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-name" }, "拎包商加盟"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-sub" }, "找个品牌,跟上拎包时代")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-index-box-tp-des" }, " 为“品牌厂家”会员招募拎包入住加盟商 ", -1))
const _hoisted_53 = { class: "fd-index-box-tabs" }
const _hoisted_54 = { class: "fd-index-box-item-img" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Promotion, Search, Expand } from "@element-plus/icons-vue";
import Bottom from "./components/bottom.vue";

interface ActivityVo {
  id: string;
  name: string;
  status: number;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  province: string;
  city: string;
  lessonName: string;
  startTimeString: string;
  endTimeDateString: string;
}
interface tabNames {
  name: string;
  count: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const investActivitys: ActivityVo[] = [];
const communityActivitys: ActivityVo[] = [];
const cultivateActivitys: ActivityVo[] = [];
const bagJoinActivitys: ActivityVo[] = [];
const investDeveloperNames: tabNames[] = [];
const communityBrandNames: tabNames[] = [];
const bagJoinBrandNames: tabNames[] = [];
const bindData = reactive({
  investDeveloperNames: investDeveloperNames,
  communityBrandNames: communityBrandNames,
  investActivitys: investActivitys,
  communityActivitys: communityActivitys,
  cultivateActivitys: cultivateActivitys,
  bagJoinBrandNames: bagJoinBrandNames,
  bagJoinActivitys: bagJoinActivitys,
  isShowDefaultImage: true,
  defaultImage: "",
  images: [],
  calssType: ["", "", "", "status3", "status4", "status5", "status6"],
  type: ["", "", "", "即将开始", "报名中", "进行中", "已结束"],
});

const activityEvent = (
  developerName: string,
  brandName: string,
  type: number,
  limit: number
) => {
  store
    .dispatch("frontIndexModule/listActivity", {
      type: type,
      limit: limit,
      developerName: developerName,
      brandName: brandName,
    })
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            // case 1:
            //   obj.statusName = "草稿";
            //   break;
            // case 2:
            //   obj.statusName = "待审核";
            //   break;
            case 3:
              obj.statusName = "即将开始";
              break;
            case 4:
              obj.statusName = "报名中";
              break;
            case 5:
              obj.statusName = "已开始";
              break;
            case 6:
              obj.statusName = "已结束";
              break;
            // case 7:
            //   obj.statusName = "已取消";
            //   break;
            default:
              obj.statusName = "--";
              break;
          }
        }
        if (type == 1) {
          bindData.investActivitys = data.result;
        }
        if (type == 2) {
          bindData.communityActivitys = data.result;
        }
        if (type == 4) {
          bindData.cultivateActivitys = data.result;
        }
        if (type == 7) {
          bindData.bagJoinActivitys = data.result;
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const developerNameEvent = () => {
  store
    .dispatch("frontIndexModule/listDeveloperName", { type: 1, limit: 6 })
    .then(
      (data) => {
        bindData.investDeveloperNames = data.result;
        if (data.result) {
          var result = data.result[0];
          if (result) {
            activityEvent(result.name, "", 1, 3);
          }
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const brandNameEvent = (type: number) => {
  store.dispatch("frontIndexModule/listBrandName", { type: type }).then(
    (data) => {
      if (type == 2) {
        bindData.communityBrandNames = data.result;
      }
      if (type == 7) {
        bindData.bagJoinBrandNames = data.result;
      }
      if (data.result) {
        var result = data.result[0];
        if (result) {
          if (type == 2) {
            activityEvent("", result.name, 2, 3);
          }
          if (type == 7) {
            activityEvent("", result.name, 7, 3);
          }
        }
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const advertisingImageEvent = () => {
  store.dispatch("frontIndexModule/listAdvertisingImage", { type: 1 }).then(
    (data) => {
      console.log(data.result);
      bindData.images = data.result;
      if (data.result.length > 0) {
        bindData.defaultImage = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const handleClick = (tab: any, event: Event) => {
  const name = bindData.investDeveloperNames[tab.index].name;
  activityEvent(name, "", 1, 3);
};

const handleClick2 = (tab: any, event: Event) => {
  const name = bindData.communityBrandNames[tab.index].name;
  activityEvent("", name, 2, 3);
};

const handleClick3 = (tab: any, event: Event) => {
  const name = bindData.bagJoinBrandNames[tab.index].name;
  activityEvent("", name, 7, 3);
};

const handleToBbsMore = () => {
  openNewWindow("/frontDesk/bbsList", {});
};

const handleToBbsList = (tagId: string) => {
  openNewWindow("/frontDesk/bbsList", {tagId: tagId});
};

const handleToMore = () => {
  openNewWindow("/frontDesk/fdInvestList", {});
};

const handleToNewMore = () => {
  localStorage.setItem("timeTypeSearch", "one_week");
  openNewWindow("/frontDesk/fdInvestList", {});
};

const handleToInvestDetail = (item: any) => {
  openNewWindow("/frontDesk/fdInvestList/fdInvestDetail/" + item.id, {});
};

const handleToBbsDetail = (item: any) => {
  openNewWindow("/frontDesk/bbsList/bbsDetail/" + item.id, {});
};

const handleToFdInvestStat = () => {
  openNewWindow("/frontDesk/fdInvestStat", {});
};

const handleToTrainingDetail = (id: string) => {
  router.push('/frontDesk/trainingIndex/trainingDetail/' + id)
}


const openNewWindow = (path: any, query: any) => {
  const { href } = router.resolve({
    path: path,
    query: query,
  });
  window.open(href, "_blank");
};

const goToTraining = (hash: any) => {
  router.push("/frontDesk/trainingIndex");
  setTimeout(function () {
    const goToHash = document.getElementById(hash);
    if (goToHash) {
      goToHash.scrollIntoView();
    }
  }, 1500);
}

developerNameEvent();
brandNameEvent(2);
brandNameEvent(7);
activityEvent("", "", 4, 3);
advertisingImageEvent();

setTimeout(() => {
  bindData.isShowDefaultImage = false;
}, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "fd-index-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "fd-index-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "fd-index-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_container, { class: "fd-index-box-tp" }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  icon: _unref(Promotion),
                  type: "primary",
                  size: "large",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToNewMore()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Search),
                  type: "primary",
                  size: "large",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToMore()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Expand),
                  type: "primary",
                  size: "large",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToFdInvestStat()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_tabs, { onTabClick: handleClick }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).investDeveloperNames, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.name,
                  key: item.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_container, { class: "fd-index-box-line" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).investActivitys, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fd-index-box-item",
                            key: item.id,
                            onClick: () => handleToInvestDetail(item)
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_el_image, {
                                class: "",
                                src: item.thumbnailUrl
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_el_container, { class: "fd-index-box-item-info-tp" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_row, {
                                gutter: 20,
                                class: "fd-index-box-item-info-ct list-row"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 14,
                                    class: "col-left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.deliveryDateString) + "收楼 | " + _toDisplayString(item.decorateTypeName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, {
                                    span: 10,
                                    class: "col-right",
                                    style: {"color":"red"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.phaseName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_row, {
                                gutter: 20,
                                class: "fd-index-box-item-info-bt list-row"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 14,
                                    class: "col-left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createVNode(_component_el_image, {
                                          class: "bbs-list-item-logo-icon",
                                          mode: "widthfix",
                                          src: item.companyLogo,
                                          style: {"width":"35px","height":"35px","margin-right":"3px"}
                                        }, null, 8, ["src"]),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(item.companyName), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.roomNumber>0)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        span: 10,
                                        class: "col-right",
                                        style: {"color":"red"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.roomNumber) + "户 ", 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ], 8, _hoisted_12))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "fd-index-box-tabs-more",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToMore()))
          }, "更多")
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_container, { class: "fd-index-box-tp" }, {
          default: _withCtx(() => [
            _hoisted_21,
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  icon: _unref(Promotion),
                  type: "primary",
                  size: "large",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleToBbsList('7a2e1c40f3154b56b6b39a1782a28dce')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Search),
                  type: "primary",
                  size: "large",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (handleToBbsList('3096a4bcbf3c4985986b442610ec8519')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Expand),
                  type: "primary",
                  size: "large",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleToBbsList('1e67c9d8ea10477998abec5051c9c16b')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_tabs, { onTabClick: handleClick2 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).communityBrandNames, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.name,
                  key: item.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_container, { class: "fd-index-box-line" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).communityActivitys, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fd-index-box-item",
                            key: item.id,
                            onClick: ($event: any) => (handleToBbsDetail(item))
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_el_image, {
                                class: "",
                                src: item.thumbnailUrl
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_el_container, { class: "fd-index-box-item-info-tp" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(item.activityTagName), 1),
                              _createVNode(_component_el_container, { class: "fd-index-box-item-info-bt" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(item.projectName || "--") + " | " + _toDisplayString(item.companyName), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ], 8, _hoisted_26))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "fd-index-box-tabs-more",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (handleToBbsMore()))
          }, " 更多 ")
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_el_container, { class: "fd-index-box-tp" }, {
          default: _withCtx(() => [
            _hoisted_34,
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  icon: _unref(Promotion),
                  type: "primary",
                  size: "large",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (goToTraining('training-1')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Search),
                  type: "primary",
                  size: "large",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (goToTraining('training-2')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_unref(ElButton), {
                  icon: _unref(Expand),
                  type: "primary",
                  size: "large",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (goToTraining('training-3')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_container, { class: "fd-index-box-line" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).cultivateActivitys, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fd-index-box-item",
                  key: item.id,
                  onClick: ($event: any) => (handleToTrainingDetail(item.id))
                }, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_el_image, {
                      class: "",
                      src: item.thumbnailUrl
                    }, null, 8, ["src"]),
                    (item.status == 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(item.statusName || "--"), 1)
                        ]))
                      : (item.status == 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(item.statusName || "--"), 1)
                          ]))
                        : (item.status == 5)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, _toDisplayString(item.statusName || "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, _toDisplayString(item.statusName || "--"), 1)
                            ]))
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_el_container, { class: "fd-index-box-item-info-bt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(item.name), 1),
                        _createElementVNode("div", null, _toDisplayString(item.province) + "." + _toDisplayString(item.city), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_container, { class: "fd-index-box-item-info-bt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(item.lessonName), 1),
                        _createElementVNode("div", null, _toDisplayString(item.startTimeString) + " ~ " + _toDisplayString(item.endTimeDateString), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 8, _hoisted_39))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_el_container, { class: "fd-index-box-tp" }, {
          default: _withCtx(() => [
            _hoisted_51,
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _hoisted_52
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_el_tabs, { onTabClick: handleClick3 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).bagJoinBrandNames, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.name,
                  key: item.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_container, { class: "fd-index-box-line" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).bagJoinActivitys, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fd-index-box-item",
                            key: item.id
                          }, [
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_el_image, {
                                class: "",
                                src: item.thumbnailUrl
                              }, null, 8, ["src"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "fd-index-box-tabs-more",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (handleToMore()))
          }, "更多")
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})